
import React, { Component } from 'react'

class NaviIconMenu extends Component {
  onNaviBarClicked (url, e) {
    e.preventDefault()
    this.props.history.push(url)
  }
  renderNaviIcon () {
    return this.naviIconSetting.map((navi, index) => {
      // 外部サイト（マニュアル等）は別タブで開くリンクにする
      if (navi.external) {
        return (
          <li key={'nave' + index} className='kw-btn-area' style={navi.itemStyle}>
            <a className={navi.linkClass} href={navi.url} target='_blank' rel='noopener noreferrer'>
              <i className={navi.iconClass} /><span>{navi.title}</span>
            </a>
          </li>
        )
      }
      return (
        <li key={'nave' + index} className='kw-btn-area' style={navi.itemStyle}>
          <a className={navi.linkClass} onClick={(e) => this.onNaviBarClicked(navi.url, e)} >
            <i className={navi.iconClass} /><span>{navi.title}</span>
          </a>
        </li>
      )
    })
  }
  render () {
    const naviIcon = this.renderNaviIcon()
    // inline: 全幅固定バーではなく、画面タイトル横などに埋め込むための描画
    if (this.props.inline) {
      return (
        <div className='body-nav body-nav-horizontal kw-navi-inline'>
          <ul>
            {naviIcon}
          </ul>
        </div>
      )
    }
    return (
      <div className='body-nav body-nav-horizontal body-nav-fixed'>
        <div className='container'>
          <ul>
            {naviIcon}
          </ul>
        </div>
      </div>
    )
  }
}

export default NaviIconMenu



// WEBPACK FOOTER //
// ./src/common/component/NaviIconMenu.js